import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, of } from 'rxjs';
import { Subject } from "rxjs";
import { switchMap } from 'rxjs/operators';
import { NbSidebarService } from '@nebular/theme';
import { FiltrosService } from '../components/filtros/filtros.service'
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ExcelService} from './excel.service';
import { AppService } from '../app.service';
import { GenpdfService } from './genpdf.service'
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import * as FileSaver from 'file-saver';

interface Dashboard {
  graficos: Array<Grafico>
  titulo: string;
}
interface Grafico {
  grafico: string;
  titulo: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  @Input() dashboardId: string;
  @Input() userid: string;
  @Input() dashboardType: string;
  @Input() userpro:boolean;
  isDataAvailable: boolean = true;
  itemsCollection: AngularFirestoreCollection<any>;
  items: Observable<any[]>
  private itemDoc: AngularFirestoreDocument<any>;
  item: Observable<any>;
  grafico1:Grafico = {'grafico': 'grafico1', 'titulo': 'China-Chile-2018'};
  grafico2:Grafico = {'grafico': 'grafico2', 'titulo': 'China-Chile-2017'};
  graficoAr:Array<Grafico> = [this.grafico1,this.grafico2];
  dashboard1:Dashboard = {'graficos':this.graficoAr,'titulo': 'Dashboard1' }
  showFilters: boolean = false;
  graficoid: string;
  dataGrafico: any;
  dataModal: any;
  fActivos: number;
  excel=[];

  constructor(private appService: AppService, private excelService: ExcelService, private afs: AngularFirestore, private sidebarService: NbSidebarService, private modalService: NgbModal, private filtrosService: FiltrosService, private genpdf:GenpdfService) {
    filtrosService.filtrosActualizados$.subscribe(
    resp => {
      this.rDataGrafico(resp);
    });

  genpdf.descargaPdf$.subscribe(
  resp => {
    this.downloadPDF();
  });
}

  loadDashboardData(userid) {

    this.itemsCollection = this.afs.collection<any>('users/'+userid+'/dashboards/'+this.dashboardId+'/graficos', ref => {
    //     // Compose a query using multiple .where() methods
         return ref
                 .orderBy("order")
       });
      this.items = this.itemsCollection.valueChanges();

  }
  rDataGrafico(data :any) {

    this.isDataAvailable = false;
    let titulo;
    if (this.dashboardType=="tradedata") {
      const origen = data.origin.split(";");
      if (data.destination) {
        titulo = data.product+" "+origen[0]+"-"+origen[1]+" "+data.destination;
      }
      else {
        titulo = data.product+" "+origen[0]+"-"+"All"+" "+origen[1];
      }
    }
    else {
      titulo = data.product + "- Contract Prices - Average Grades - US$/ton";
    }
    const graphRef: AngularFirestoreDocument<any> = this.afs.doc('users/'+this.userid+'/dashboards/'+this.dashboardId+'/graficos/'+this.graficoid);

    const gdata = {
      grafico: data,
      titulo: titulo
    }
    graphRef.set(gdata, { merge: true });
  }
  addChart(index) {
    const id = this.afs.createId();
    const chartRef: AngularFirestoreDocument<any> = this.afs.doc('users/'+this.userid+'/dashboards/'+this.dashboardId+'/graficos/'+id);
    const data ={
      id:id,
      titulo:"New chart",
      order:index
    }

    chartRef.set(data, { merge: true })
    this.displayFilters(id,index,null);
  }
  updateChart() {

  }
  displayFilters(id,index, dataGrafico) {

    if (dataGrafico) {
      dataGrafico.dashboardType=this.dashboardType;
    }
    else {
      dataGrafico ={dashboardType:this.dashboardType}

      dataGrafico.dashboardType=this.dashboardType;
    }
    this.graficoid = id;
    this.showFilters=true;
    this.filtrosService.cargarFiltros(dataGrafico);
    this.fActivos=index;
    this.sidebarService.expand('right');

  }
  hideSB() {
    this.sidebarService.collapse('right');
  }

  deleteGraph(content, item) {
    this.dataModal= item;
    this.modalService.open(content);
  }
  deleteChart (chartData) {
    const chartRef: AngularFirestoreDocument<any> = this.afs.doc('users/'+this.userid+'/dashboards/'+this.dashboardId+'/graficos/'+chartData.id);
    chartRef.delete();
    //this.modalService.close('deleted');
    this.modalService.dismissAll('deeted');
  }
  downloadPDF() {
    var data = document.getElementById('contentToConvert');
    document.getElementById('right-sidebar').style.display ="none";
    setTimeout(() => {
      html2canvas(data).then(canvas => {
        // Few necessary setting options
        var imgWidth = 208;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        let pdf = new jspdf('p', 'mm', 'a4', true); // A4 size page of PDF
        var position = 0;
        pdf.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, 'SLOW')
        pdf.save('MYPdf.pdf'); // Generated PDF
        document.getElementById('right-sidebar').style.display ="block";
        //console.log(contentDataURL);
      });
  }, 5);

  }
  async downloadData(grafico) {
    console.log(grafico);
    const json1 = await this.getExcelData(grafico);

    let origen = grafico.origin.split(";")
    if (!grafico.destination) {
      grafico.destination = 'All'
    }

    setTimeout(() => {
      this.excelService.exportAsExcelFile(json1, 'Limetric_Report '+grafico.product+' '+origen[0]+' '+origen[1]+' '+grafico.destination+' ');
  }, 100);

  }
  async getExcelData(body) {
    let exportedData=[];
    try {
      this.appService.getGraphData(body)
        .subscribe(databb => {
          let data: any = []
          data= databb;
          //let data = JSON.parse(databb.toString());
           data.forEach(row => {

             if (body.input=='tonnes' && this.dashboardType=='tradedata') {
               //row.tonnes = Math.round(row.tonnes)
               delete row.usfob
             }
             else if (body.input=='usfob' && this.dashboardType=='tradedata') {
               let result = Math.round(row.usfob/row.tonnes);
               delete row.tonnes;
               row.usfob = result;
             }
             else if (this.dashboardType=='liprices') {
               let price =row.usfob/row.tonnes*1.1;
               row.minprice = Math.round(price*0.95);
               row.maxprice = Math.round(price*1.05);
               delete row.usfob;
               delete row.tonnes;

             }
             exportedData.push(row);
           });
        },
          error => {
            console.log(error, "error");
          })
    }

     catch (e) {
      console.log(e);
    }
    return exportedData;
  }

  ngOnInit() {
    this.loadDashboardData(this.userid);
  }
  ngOnChanges(changes: SimpleChanges) {
    this.loadDashboardData(this.userid);
  }
}
